(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-upgrade-btn]');
    if (!btn) return;

    var card = btn.closest('.cart-set-upsell');
    if (!card || card.classList.contains('cart-set-upsell--loading')) return;

    var flagKey = card.dataset.flagKey;
    var flagQty = parseInt(card.dataset.flagQty, 10) || 1;
    var setVariantId = parseInt(card.dataset.setVariantId, 10);
    var errorEl = card.querySelector('.cart-set-upsell__error');

    // Clear previous errors
    if (errorEl) errorEl.textContent = '';

    // Fade the parent cart line item + lock upsell card
    var lineItem = card.closest('[data-merge-list-item]');
    if (lineItem) lineItem.style.opacity = '0.4';
    card.classList.add('cart-set-upsell--loading');

    // Step 1: Add the set (safe — if this fails, nothing changes)
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: setVariantId, quantity: flagQty }]
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Could not add set to cart');
      // Step 2: Remove the flag
      var updates = {};
      updates[flagKey] = 0;
      return fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Could not remove item');
      // Step 3: Refresh the cart drawer
      document.dispatchEvent(new CustomEvent('on:cart:change', {
        bubbles: true,
        cancelable: false
      }));
    })
    .catch(function(err) {
      // Restore line item + unlock card
      if (lineItem) lineItem.style.opacity = '';
      card.classList.remove('cart-set-upsell--loading');
      if (errorEl) {
        errorEl.textContent = 'Something went wrong. Please try again.';
      }
    });
  });
})();
